<li class="row text-truncate w-100 py-0 g-0 d-flex align-items-center">

  <context-menu #folderContextMenu  class="bg-danger" >

    <ng-template contextMenuItem let-value  (execute)="executeContextMenu.emit({action:ContextMenuActionEnum.NEW_DIRECTORY, event: $event})">

      <i class="fa fa-folder-plus"></i> New Folder


    </ng-template>

    <ng-template contextMenuItem let-value   (execute)="executeContextMenu.emit({action: ContextMenuActionEnum.UPLOAD_FILE, event: $event})">
      <i class="fa fa-cloud-upload"></i> Upload File
    </ng-template>
    <ng-template contextMenuItem let-value   (execute)="executeContextMenu.emit({action: ContextMenuActionEnum.UPLOAD_DIRECTORY, event: $event})">
      <i class="fa fa-upload"></i> Upload Folder
    </ng-template>

    <ng-template contextMenuItem let-value   (execute)="executeContextMenu.emit({action: ContextMenuActionEnum.RENAME, event: $event})">
      <i class="fa fa-edit"></i> Rename
    </ng-template>


    <ng-template contextMenuItem let-value   (execute)="executeContextMenu.emit({action: ContextMenuActionEnum.DELETE, event: $event})">
      <i class="fa fa-trash"></i> Delete
    </ng-template>
    <ng-template contextMenuItem [divider]="true"></ng-template>

    <ng-template contextMenuItem let-value   (execute)="executeContextMenu.emit({action: ContextMenuActionEnum.RELOAD, event: $event})">
      <i class="fa fa-refresh"></i> Refresh
    </ng-template>

  </context-menu>

  <div class="folder-container  align-items-center" [class.folder-active]="currentPath.value === (attachment.path === '/'? attachment.path : attachment.path + '/' ) + attachment.name"
       dndDropzone
       dndDragoverClass="folder-dragover"
       (dndDragover)="dndDragover.emit({$event, attachment})"

       [dndDisableDropIf]="currentDragAttachment?.id === attachment.id ||(currentDragAttachment?.path === attachment.path + '/' + attachment.name) || (!!currentDragAttachment && currentDragAttachment!.type === 'directory' && attachment!.path.startsWith(currentDragAttachment!.path + '/' + currentDragAttachment!.name))"
       (dndStart)="dndStart.emit({$event, attachment})"
       (dndCanceled)="dndCanceled.emit({$event, attachment})"
       [dndDraggable]="attachment"

       (dndDrop)="dndDrop.emit({$event, attachment: $event.data, path: attachment.path +'/' + attachment.name})"
       (dndEnd)="dndEnd.emit({$event, attachment})"

  >




    <div class="folder-name py-1  ps-1 "
         (click)="clickedOnFolder($event, attachment)"
         [contextMenu]="$any(folderContextMenu)"
         #ngxContextMenu="ngxContextMenu"
         [contextMenuValue]="attachment"
    >
            <i class="fa fa-folder text-gray-500 mx-1" ></i>

            {{  attachment.name }}


    </div>

    <div class="folder-context-menu pointer py-1 text-end" (click)="ngxContextMenu.open($event)">
      <div class="pe-2 " >
        <i class="fa fa-ellipsis-v text-gray-400 "></i>
      </div>
    </div>



  </div>



  <ul class="ps-3">


    <ng-container  *ngFor="let subAttachment of (attachmentsByPath.value[(attachment.path === '/' ? attachment.path : attachment.path + '/')  + attachment.name])">
      <app-folder
        *ngIf="subAttachment.type === 'directory'"
        [attachment]="subAttachment"
        [currentPath]="currentPath"
        [attachmentsByPath]="attachmentsByPath"
        [currentDragAttachment]="currentDragAttachment"

        (clicked)="clicked.emit($event)"
        (newDirectory)="newDirectory.emit($event)"
        (uploadFiles)="uploadFiles.emit($event)"
        (executeContextMenu)="executeContextMenu.emit($event)"
        (loadPath)="loadPath.emit($event)"
        (refresh)="refresh.emit($event)"
        (dndDrop)="dndDrop.emit($event)"
        (dndEnd)="dndEnd.emit($event)"
        (dndStart)="dndStart.emit($event)"
        (dndCanceled)="dndCanceled.emit($event)"
        (dndDragover)="dndDragover.emit($event)"
      >

      </app-folder>

    </ng-container>


  </ul>
</li>
